import { SET_CARRITOPROMOS } from "../constanst";
import * as constant from '../../global/const';

export function setCarritoPromos(carritoPromos) {
    localStorage.setItem(constant.CARRITOPROMO, JSON.stringify(carritoPromos));
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_CARRITOPROMOS,
                payload: carritoPromos,
            });

        } catch (error) {
            console.log(error);
        }
    }
}